var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"id":"payment-form"}},[_c('div',{attrs:{"id":"payment-element"}}),_c('button',{attrs:{"id":"submit"}},[_c('div',{staticClass:"spinner hidden",attrs:{"id":"spinner"}}),_c('span',{ref:"payNow",attrs:{"id":"button-text"}},[_vm._v("Pay now")])]),_c('div',{staticClass:"hidden",attrs:{"id":"payment-message"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }